import React from 'react';
import * as ReactDOM from 'react-dom';
import QRCode from '../../../../services/external/qrcode';

class QrCodeView extends React.Component {

    componentDidMount() {
        this.fillQrCode();
    }

    componentDidUpdate() {
        this.fillQrCode();
    }

    shouldComponentUpdate(nextProps) {
        var curProps = this.props;

        if (curProps.text !== nextProps.text) {
            return true;
        }
        return false;
    }

    fillQrCode() {
        let {text} = this.props;
        let qrCodeContainer = ReactDOM.findDOMNode(this.refs.qrCodeContiner);
        qrCodeContainer.innerHTML = '';
        var qrcode = new QRCode(qrCodeContainer, {
            text: text,
            width: 172,
            height: 172,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.L
        });
    }

    render() {
        return (
            <div className="qr-code" ref="qrCodeContiner"/>
        );
    }
}

export default QrCodeView;